import React from 'react';
import ErrorBoundary from '../../../shared/error-boundary';
import SidebarItem from './common/sidebar-item';

export default function MyWiresSidebar() {
  const requiresWireReview = window.Livewire?.currentUser?.profile?.requiresWireReview;

  return (
    <ErrorBoundary>
      <ul className="sidebar-menu">
        <SidebarItem href="/profiles/me/my_wires/published" text="Published" />
        <SidebarItem href="/profiles/me/my_wires/drafts" text="Drafts" />
        {requiresWireReview && (
          <SidebarItem href="/profiles/me/my_wires/pending" text="Pending" />
        )}
        <SidebarItem href="/profiles/me/my_wires/comments" text="Comments" />
      </ul>
    </ErrorBoundary>
  );
}
